import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { BRANDING } from "@/config/branding";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState("loading"); // loading | ok | error

  useEffect(() => {
    if (!token) { setState("error"); return; }
    api.post("/auth/verify-email", { token }).then(() => setState("ok")).catch(() => setState("error"));
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-md fade-up text-center">
        <div className="font-display text-3xl gold-text tracking-wider mb-6">{BRANDING.name}</div>
        <div className="glass-card rounded-3xl p-10">
          {state === "loading" && (<><Loader2 className="animate-spin text-[#C6A45C] mx-auto mb-4" size={32} /><p className="text-[#8A7F70]">Verifying your email…</p></>)}
          {state === "ok" && (
            <>
              <div className="w-14 h-14 rounded-full bg-[#8FB996]/15 flex items-center justify-center mx-auto mb-4"><CheckCircle2 size={26} className="text-[#5a9a6a]" /></div>
              <h1 className="font-display text-2xl font-light text-[#2C2A28] mb-2">Email verified</h1>
              <p className="text-[#8A7F70] text-sm mb-5">Thank you — your Financial Home is fully secured.</p>
              <Link to="/" data-testid="verify-home" className="gold-text underline text-sm">Go to Home</Link>
            </>
          )}
          {state === "error" && (
            <>
              <div className="w-14 h-14 rounded-full bg-[#C99FA0]/15 flex items-center justify-center mx-auto mb-4"><XCircle size={26} className="text-[#b06b6b]" /></div>
              <h1 className="font-display text-2xl font-light text-[#2C2A28] mb-2">Link invalid or expired</h1>
              <p className="text-[#8A7F70] text-sm mb-5">Please request a fresh verification link from inside the app.</p>
              <Link to="/" className="gold-text underline text-sm">Go to Home</Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
